export const ko = {
    // Header
    'header.title': '🎭 킨 폭로',
    'header.subtitle': 'Tom Kean Jr. (NJ-7) — 당신의 건강보험에 관심 없습니다.',

    // Hero Section
    'hero.quote': 'Tom Kean Jr.: "유권자들에게는 독립적이라고 말하고, 그러고는 MAGA와 투표합니다."',
    'hero.subtext': '4명의 공화당원이 ACA 보조금을 지키기 위해 당에 반기했습니다. 12월 17일, 4명의 GOP 의원이 용기를 보여주고 투표를 강제하기 위해 민주당과 함께했습니다. Tom Kean Jr. (NJ-7)? 그는 침묵을 지켰습니다. 12월에 Kean은 ACA 보조금 연장을 요구하는 공화당의 서한에 17명의 공화당 상원의원과 함께 이름을 올렸지만, 하원 공화당과 함께 연장을 막는 데 표를 던졌습니다. 2,200만 미국인이 1월 1일부터 114% 보험료 인상에 직면합니다.',

    // Breaking News
    'breaking.news': '🚨 속보: 뉴저지 병원 수입이 팬데믹 이후 급증했습니다. CEO 보수도 함께 올랐습니다',

    // Kean Did Not Support Section
    'kean.betrayal.title': 'TOM KEAN JR.는 당신을 위해 나서기를 거부했습니다',
    'kean.betrayal.text': '12월 17일, 경합 지역출신 4명의 공화당 의원(Brian Fitzpatrick, Rob Bresnahan Jr., Ryan Mackenzie는 PA에서, Mike Lawler는 NY에서)이 당에 반기하고 ACA 보조금 연장에 대한 투표를 강제하기 위해 민주당과 함께했습니다. Tom Kean Jr. 하원의원(NJ-7)은 그들 중 한 명이 아니었습니다. 그는 당신의 건강보험보다 당에 대한 충성을 선택했습니다.',
    'kean.betrayal.comparison': '이 4명의 공화당원은 용기를 보여주었습니다. Kean은 비겨함을 보여주었습니다.',
    'kean.betrayal.cta': 'Kean에게 물어보세요: 왜 우리를 위해 나서지 않았나요?',

    // Healthcare Context Section
    'context.title': '공화당은 당신의 건강보험에 관심 없습니다: "건강 비용 쓰나미"는 이제 현실입니다',
    'context.intro': '공화당 하원의원 Tom Kean Jr. (NJ-7)는 당신의 건강보험을 위해 아무것도 하지 않았습니다. 보험료, 진료비, 처방약 등 모든 것에 더 많은 비용을 지불할 준비를 하세요. 어떻게 감당하시겠습니까? 12월 16일, 하원 공화당이 ACA 보조금 연장을 위한 민주당의 노력을 부결시켰습니다. 민주당은 당신의 건강보험을 위해 싸워왔습니다 — ACA를 통과시키고, 주요 의약품의 처방약 가격을 낮추는 등. 하지만 Tom Kean Jr.는 당에 동조하여 이러한 보호 조치가 만료되도록 투표했습니다.',
    'context.truth.title': '진실: NJ 가정에 미치는 실제 영향',
    'context.truth.text': 'NJ Mahwah 거주민 Tina Jump는 자신의 ACA 보험료가 <strong>월 $400에서 $1,100 이상으로</strong> — 거의 세 배로 급등할 것이라는 것을 알게 되었습니다. "이걸 어떻게 지불해야 할지 모르겠어요," 그녀가 CBS News에 말했습니다.',
    'context.impact': '세금 공제를 받을 자격이 있는 <strong>2,200만 미국인</strong>이 어려운 재정 결정에 직면해 있습니다. 자기부담 보험료 비용은 <strong>평균 114% 증가</strong>하여 연간 비용이 $1,016 증가합니다. 연간 $75,000를 버는 4인 가족은 추가로 <strong>$3,368</strong>의 보험료 인상을 볼 수 있습니다.',
    'context.tsunami': '"1월 1일에 건강 비용이 급증하는 쓰나미를 보게 될 것입니다," Community Catalyst의 Michelle Sternthal이 말했습니다. 의회 예산국에 따르면 높은 보험료로 인해 약 <strong>400만 명이 건강보험을 해지</strong>할 수 있습니다.',
    'context.exposed.title': '폭로: 가장 취약한 사람은 누구인가?',
    'context.exposed.text': '소기업주와 자영업자가 특히 위험합니다. ACA에 등록된 성인의 약 절반이 소기업주, 25명 미만의 직원을 가진 회사에 고용된 사람, 또는 자영업자입니다.',
    'context.accountability': 'Tom Kean Jr. 하원의원(NJ-7)은 당에 동조하여 이러한 보조금이 만료되도록 투표했습니다. 민주당 의원들은 ACA 보험료 세금 공제 연장에 대한 투표를 강제하기 위한 탄원서를 돌리고 있습니다. 하원을 이기는 길은 뉴저지를 직접 통과합니다. 그에게 책임을 물을 때입니다.',
    'context.cta': '지금 행동하세요',

    // ACA Section
    'aca.title': '공화당이 당신의 건강보험을 빼앗고 있습니다 — ACA 보조금은 12월 31일에 만료되었습니다',
    'aca.text': '하원 공화당이 12월 16일 ACA 보조금 연장을 차단했습니다. 1월 1일부터 보험료가 평균 114% 급등합니다. 연간 $72,000를 버는 Mahwah 거주민과 같은 일부 가정은 비용이 거의 세 배로 — 월 $400에서 $1,100 이상으로 증가할 것입니다. Tom Kean Jr. 하원의원(NJ-7)은 이 생명줄을 차단하기 위해 당에 동조하여 투표했습니다.',
    'aca.chart.title': '평균 보험료 인상',
    'aca.chart.2025': '2025',
    'aca.chart.2026': '2026',
    'aca.chart.withSubsidies': '보조금 포함',
    'aca.chart.increase': '+114% 평균',

    // No Kean Day Section
    'nokean.title': '노 킨 데이!',
    'nokean.date': '매달 7일.',
    'nokean.message': '그에게 메시지를 보내세요!',
    'nokean.standup': '건강보험을 위해 일어나세요',
    'nokean.handle': '@CongressmanKean',
    'nokean.caption': '"거울이 불편해서 타운홀을 피합니다."',

    // Voting Record Section
    'voting.title': '📜 영수증은 명확합니다',
    'voting.record.title': 'Tom Kean Jr.의 투표 기록',
    'voting.bill.name': 'H.R.1 - 하나의 크고 아름다운 법안',
    'voting.bill.congress': '119대 의회 (2025-2026) | 공법 119-21',
    'voting.bill.rollcall': '호명 투표 #145 | 2025년 5월 22일',
    'voting.bill.cut1': '• ACA 보조금 삭감 - 174% 보험료 인상 야기',
    'voting.bill.cut2': '• NJ 가정에 영향을 미치는 메디케이드 자금 감소',
    'voting.breakdown.title': '투표 분석',
    'voting.breakdown.yeas': '✓ 찬성: 215 (모든 공화당)',
    'voting.breakdown.nays': '✗ 반대: 214 (모든 민주당)',
    'voting.breakdown.present': '출석: 1',
    'voting.breakdown.notvoting': '불참: 2',
    'voting.breakdown.passed': '통과',
    'voting.kean.name': 'TOM KEAN JR.',
    'voting.kean.title': '하원의원, NJ-7',
    'voting.kean.vote': '찬성',
    'voting.kean.result': '건강보험 삭감에 투표함',
    'voting.source': '출처: 미국 하원 서기실 | clerk.house.gov/Votes/2025145',
    'voting.cta.vote': 'Kean의 투표 보기',
    'voting.cta.bill': '법안 읽기 (H.R.1)',

    // Medicaid Section
    'medicaid.title': 'Tom Kean Jr.: "저는 이것을 \'재정 책임\'이라고 부릅니다"',
    'medicaid.text': 'Tom Kean Jr. 하원의원(NJ-7)은 노인, 어린이, 장애인을 위협하는 메디케이드 삭감을 지지했습니다. 이러한 삭감은 의사, 병원, 장기 요양에 대한 접근을 줄입니다. 모든 투표가 진실을 말합니다 — 그가 말하지 않더라도.',
    'medicaid.visual': '메디케이드 = 생명줄',
    'medicaid.hashtags': '#킨폭로 #돈을따라가라',
    'medicaid.hashtags.text': '#킨폭로 #돈을따라가라 #공화당은건강보험에관심없다',

    // Medicare Section
    'medicare.title': 'Tom Kean Jr.: "목소리를 잃지 않았습니다. 트럼프에게 줬습니다."',
    'medicare.subtext': '공화당 제안에는 수천억 달러의 메디케어 감축이 포함되어 있습니다. Tom Kean Jr. 하원의원(NJ-7)은 이러한 노력에 동조하여 노인들의 건강보험을 위협하고 있습니다.',
    'medicare.bullet1': 'GOP 예산 초안은 메디케어에서 $4,790억 삭감을 제안합니다 (지불 구조, 자격 변경).',
    'medicare.bullet2': '"하나의 크고 아름다운 법안"에는 메디케어 접근을 제한하는 조항이 포함되어 있었습니다.',
    'medicare.bullet3': 'NJ-7의 노인들은 병원 방문, 처방약, 장기 요양을 위해 메디케어에 의존합니다.',
    'medicare.cta': '메디케어 보호 — 행동하세요',
    'medicare.visual': '메디케어 = 생명줄.\nQR 코드를 스캔하여 행동하세요.',

    // Accountability Section
    'accountability.title': '가면이 벗겨졌습니다. Tom Kean Jr.에게 책임을 물으세요.',
    'accountability.text': '"때때로 침묵은 금이 아닙니다. 조심을 가장한 비겁함입니다." Tom Kean Jr. 하원의원(NJ-7)의 기록은 명확합니다: 더 높은 비용, 더 적은 치료, 더 많은 고난. NJ-7은 더 나은 것을 받을 자격이 있습니다.',
    'accountability.cta': '#킨찾기금요일 참여하기',

    // News Sources Section
    'news.title': '📰 더 많은 영수증',
    'news.updated': '2026년 6월 23일 업데이트',
    'news.cbs': 'CBS News: 수백만 명이 보험료 급등에 직면',
    'news.wsj': 'NY Times: 트럼프가 메디케이드 근로 요건 규칙을 강화',
    'news.bloomberg': 'Bloomberg: 의료비가 기름값·식료품보다 더 큰 걱정',
    'news.nytimes': 'NY Times: 4명의 공화당원이 투표를 강제하기 위해 당에 반기',
    'news.nytimes2': 'NY Times: 하원, 오바마케어 보조금 연장 차단',
    'news.nytimes3': 'NY Times: 공화당원들이 민주당 제안을 끝까지 밀어붙여',
    'news.cnn': 'CNN: 미국인 의료비 지출 사상 최고',
    'news.nytimes4': 'NY Times: 오바마케어 건강보험 축소',
    'news.nytimes5': '센트럴 저지: 뉴저지 트랜스젠더 의료 보호 법안이 위원회로 이동',
    'news.localHospitals': 'North Jersey: 메디케이드 삭감으로 NJ 병원 12곳이 폐쇄 위기에',
    'news.localCoverage': 'North Jersey: 트럼프 예산안 이후 뉴저지 주민 35만 명이 의료 보장을 잃을 수 있다',

    // Footer
    'footer.tagline': '진실은 아프다. 거짓말은 더 비싸다. 공화당은 당신의 건강보험에 관심 없습니다.',
    'footer.hashtags': '#킨폭로 #왕은없다 #공화당은건강보험에관심없다',
    'footer.disclaimer': '진실은 아프다. 거짓말은 더 비싸다. 공화당은 당신의 건강보험에 관심 없습니다. #킨폭로 #왕은없다 #공화당은건강보험에관심없다',
    'footer.terms': '이용약관',
    'footer.privacy': '개인정보 보호정책',
    'footer.contact': '연락처',
};

export default ko;
